import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class AddHoliday extends Component {
  constructor() {
    super();
    this.add_new_event = this.save_new_event_data.bind(this);
    this.state = {
      send_button : <button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_new_event}>Save</button>,
    };
  }

componentDidMount(){

}
save_new_event_data(){
    var cutThis               = this;
    var holiday_title         = window.isNullAndUndef($('#holiday_title').val());
    var holiday_date          = window.isNullAndUndef($('#holiday_date').val());
    var holiday_description   = window.isNullAndUndef($('#holiday_description').val());
    var holiday_status        = window.isNullAndUndef($('#holiday_status').val());


    var web_token             = window.isNullAndUndef($('#web_token').val());
    var send_button           = <button className="btn btn-primary w-100 py-3" type="button">Save</button>;
    cutThis.setState({send_button});

    if(holiday_title && holiday_date && holiday_description && holiday_status){
      var body          = new FormData();
      body.append('holiday_title',holiday_title);
      body.append('holiday_date',holiday_date);
      body.append('description',holiday_description);
      body.append('holiday_status',holiday_status);
      body.append('web_token',web_token);
      body.append('function','add_holiday_data');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_holiday_manage_url.php";
      }else{
        url = "/php/admin_holiday_manage_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          console.log(data);
          if(data['error']>0){
            $('#error_msg').text(data['msg']);
            send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.props.close_popup_view}>Close</button>;
            cutThis.setState({send_button});
          }else{
            $('#error_msg').text('Error - 400');
            send_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.save_new_event_data.bind(cutThis)}>Save</button>;
            cutThis.setState({send_button});
          }

       })
       .catch(function (error) {
           console.log(error);
       });
    }else{
      window.change_lable_color('holiday_title','holiday_date','holiday_description','holiday_status');
    }
}

  render() {
    return (
        <>
        <div className="modal fade" id="myModal" role="dialog">
          <div className="modal-dialog popup_view_width">
            <div className="modal-content">
              <div className="modal-header">
              <h4 className="modal-title" id="page_titlte">Add Holiday</h4>
                <button type="button" className="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
              </div>
              <div className="modal-body">


              <div className="">
              <div className="col-md-12">
                  <div className="wow fadeInUp" data-wow-delay="0.5s">
                      <form action="" method="post">
                          <div className="row g-3">

                              <div className="col-md-6">
                                  <div className="form-floating">
                                      <input type="text" className="form-control" id="holiday_title" placeholder="Title"/>
                                      <label for="name">Title</label>
                                  </div>
                              </div>

                              <div className="col-md-6">
                                  <div className="form-floating">
                                      <input type="date" className="form-control" id="holiday_date" placeholder="Title"/>
                                      <label for="name">Date</label>
                                  </div>
                              </div>

                              <div className="col-md-6">
                                  <div className="form-floating">
                                      <input type="text" className="form-control" id="holiday_description" placeholder="Title"/>
                                      <label for="name">Description</label>
                                  </div>
                              </div>

                              <div className="col-md-6">
                                  <div className="form-floating">
                                      <select class="form-control form-select" id="holiday_status" name="holiday_status">
                                      <option value="">Status</option>
                                      <option value="Active">Active</option>
                                      <option value="Inactive">Inactive</option>
                                  </select>
                                  <label for="name">Status</label>
                                  </div>
                              </div>

                                  <div className="col-md-8">
                                    <p className="error_msg_note" id="error_msg"></p>
                                  </div>
                                  <div className="col-md-4 p-0 float_r">
                                      {this.state.send_button}
                                  </div>



                          </div>
                      </form>
                  </div>
              </div>
              </div>


              </div>
            </div>
          </div>
        </div>


        </>
    );
  }
}

export default AddHoliday;
